import {
    Dossier,
    DossierArticlesPatchResponseJsonldRead,
    DossierOpenSearch,
    useFormaliteService,
} from '@europrocurement/l2d-domain';
import {
    DossierApiApiDossiersIdArticlesPatchRequest,
    FproPrestationArticleDtoDossierUpdateArticle,
    DossierApiApiDossiersIdPatchRequest,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';
import { UpdateDossierPayload } from '../types/UpdateDossierPayload';

const useDossier = () => {
    const { dossierApi } = useFormaliteService();

    const updateDossier = (
        id: number,
        payload: UpdateDossierPayload,
        unrestricted?: boolean,
    ): Promise<Dossier> =>
        new Promise((resolve, reject) => {
            const requestParameter: DossierApiApiDossiersIdPatchRequest = {
                id: id as unknown as string,
                dossierCombinedJsonld: {
                    client: payload.clientId,
                    typeFacturation: payload.typeFacturation,
                    formaliste: payload.formaliste,
                    societeRef: payload.societeRef,
                },
                unrestricted,
            };

            dossierApi
                .apiDossiersIdPatch(requestParameter)
                .then((res) => {
                    resolve(res.data as Dossier);
                })
                .catch((err) => {
                    reject(err);
                });
        });

    const addDossiersInGroups = (
        dossiers: Array<DossierOpenSearch>,
        newGroupIds: Array<number>,
    ): Promise<void> =>
        new Promise((resolve, reject) => {
            const dossierIds = dossiers.map((dossier) => dossier.id as number);
            const requestParameter = {
                dossierDossiersGroupesPatchRequestDto: {
                    dossiers: dossierIds,
                    groups: newGroupIds,
                },
            };
            dossierApi
                .apiDossiersGroupesPatch(requestParameter)
                .then(() => resolve())
                .catch(() => reject());
        });

    const updateDossierArticles = (
        id: number,
        articles: Array<FproPrestationArticleDtoDossierUpdateArticle>,
    ): Promise<DossierArticlesPatchResponseJsonldRead> =>
        new Promise((resolve, reject) => {
            const requestParameter: DossierApiApiDossiersIdArticlesPatchRequest = {
                id: id as unknown as string,
                dossierDossiersArticlesPatchRequestDtoDossierUpdateArticle: {
                    articles,
                },
            };

            dossierApi
                .apiDossiersIdArticlesPatch(requestParameter)
                .then((res) => {
                    resolve(res.data as DossierArticlesPatchResponseJsonldRead);
                })
                .catch(() => {
                    reject();
                });
        });
    return { updateDossier, addDossiersInGroups, updateDossierArticles };
};

export default useDossier;
